<template>
    <div id="features">
        <Section class="lg:hidden block">
            <template #section>
                {{ $t('budgets_landing_page.features') }}
            </template>
            <template #title>
                {{ $t('budgets_landing_page.features_subtitle') }}
            </template>
            <div class="mt-10">
                <div class="bg-gray-200 bg-opacity-75 border border-b-0 border-gray-300 rounded-t-lg">
                    <div class="sm:overflow-visible flex px-4 py-4 overflow-x-auto">
                        <div class="gap-x-4 sm:mx-auto relative z-10 flex whitespace-no-wrap">
                            <button @click="activeTabIndex = tabIndex" v-for="(tab, tabIndex) in tabs" :class="[tabIndex === activeTabIndex ? 'border-blue-500 bg-blue-500 text-blue-50' : 'border-blue-500 bg-transparent text-blue-500', 'focus:outline-none group relative rounded-full border px-4 py-1 overflow-hidden']">
                                {{ tab.title }}
                            </button>
                        </div>
                    </div>
                </div>
                <div v-for="(tab, tabIndex) in tabs" :class="[tabIndex === activeTabIndex ? 'block border border-gray-300 border-t-0 overflow-hidden rounded-b-lg shadow-xl w-full' : 'hidden']">
                    <div class="p-4 bg-gray-200 bg-opacity-75">
                        <p class="mb-0 text-sm font-normal">
                            {{ tab.description }}
                        </p>
                    </div>
                    <div class="border-t border-gray-300">
                        <img :src="tab.imagePath" :alt="tab.title" />
                    </div>
                </div>
            </div>
        </Section>
        <div class="lg:block hidden">
            <div class="py-24">
                <h2 class="self-center my-0 text-base font-semibold leading-7 text-center text-blue-500">
                    {{ $t('budgets_landing_page.features') }}
                </h2>
                <p class="mb-14 text-gray-body text-opacity-90 self-center mt-0 text-3xl font-medium leading-snug tracking-tight text-center">
                    {{ $t('budgets_landing_page.features_subtitle') }}
                </p>
                <div ref="lgSectionContainer" class="flex">
                    <div class="self-center space-y-2" style="width: 33%;">
                        <button @click="activeTabIndex = tabIndex" v-for="(tab, tabIndex) in tabs" :class="[tabIndex === activeTabIndex ? 'border-blue-300 bg-gray-200 bg-opacity-75' : 'hover:bg-gray-200 hover:bg-opacity-75', 'border border-r-0 focus:outline-none border-transparent group rounded-l-lg p-3 pr-6 overflow-hidden text-left']">
                            <h3 class="mt-0 text-xl font-medium">
                                {{ tab.title }}
                            </h3>
                            <p class="mb-0 text-sm font-normal">
                                {{ tab.description }}
                            </p>
                        </button>
                    </div>
                    <div class="flex-1">
                        <div v-for="(tab, tabIndex) in tabs" :class="[tabIndex === activeTabIndex ? 'block overflow-hidden rounded-l-lg shadow-xl border' : 'hidden']">
                            <img :src="tab.imagePath" :alt="tab.title" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Container>
            <div ref="defaultContainer"></div>
        </Container>
    </div>
</template>

<script>
import Section from '../../../../shared/section.vue';
import Container from '../../../../shared/container.vue';

export default {
    components: {
        Section,
        Container,
    },

    mounted() {
        const defaultContainer = this.$refs.defaultContainer;
        const computedStyle = window.getComputedStyle(defaultContainer);
        const defaultContainerWidth = parseInt(computedStyle.width);
        if (! isNaN(defaultContainerWidth)) {
            const screenWidth = window.innerWidth;
            const marginLeft = (screenWidth - defaultContainerWidth) / 2;
            this.$refs.lgSectionContainer.style.marginLeft = `${marginLeft}px`;
            this.$refs.lgSectionContainer.style.marginRight = '0px';
        }
    },

    data() {
        return {
            activeTabIndex: 0,
        };
    },

    computed: {
        tabs() {
            const tabs = [
                {
                    title: this.$t('budgets_landing_page.features_tab_1_title'),
                    description: this.$t('budgets_landing_page.features_tab_1_description'),
                    imagePath: '/images/marketing/features/project-status.png',
                },
                {
                    title: this.$t('budgets_landing_page.features_tab_2_title'),
                    description: this.$t('budgets_landing_page.features_tab_2_description'),
                    imagePath: '/images/marketing/features/subdivisions.png',
                },
                {
                    title: this.$t('budgets_landing_page.features_tab_3_title'),
                    description: this.$t('budgets_landing_page.features_tab_3_description'),
                    imagePath: '/images/marketing/features/subdivision.png',
                },
                {
                    title: this.$t('budgets_landing_page.features_tab_4_title'),
                    description: this.$t('budgets_landing_page.features_tab_4_description'),
                    imagePath: '/images/marketing/features/automations.png',
                },
            ];

            return tabs;
        },
    },
};
</script>
